<template>
  <b-form-invalid-feedback :id="id"
                           class="text-error"
                           role="alert"
                           aria-live="polite"
                           aria-invalid="true"
                           :class="{'d-block': forceShow}">
    <slot></slot>
  </b-form-invalid-feedback>
</template>

<script>
export default {
  name: 'error-feedback',

  props: {
    id: {
      type: String,
      default: 'errorFeedback'
    },

    forceShow: {
      type: Boolean,
      default: false
    }
  }
}
</script>
